import { useMemo } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import {
  IconUpload,
  IconFileText,
  IconContract,
  IconPlus,
} from "@tabler/icons-react";
import { Tabs } from "@mantine/core";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import DocumentGenerators from "./DocumentGenerators";

export default function Documents() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabValue = searchParams.get("tab") || "documents";

  const handleTabChange = (tab) => {
    setSearchParams({ tab });
  };

  const actions = useMemo(() => {
    if (tabValue === "documents") {
      return [
        {
          label: "Upload",
          icon: <IconUpload />,
          navigate: "/app/documents/batch-upload",
        },
      ];
    }
    if (tabValue === "templates") {
      return [
        {
          label: "Create",
          icon: <IconPlus />,
          navigate: "/app/documents/document-templates/create",
        },
      ];
    }
    return [];
  }, [tabValue]);

  useSetActionButtons(actions);

  return (
    <Tabs
      keepMounted={false}
      variant="outline"
      value={tabValue}
      onChange={handleTabChange}
    >
      <Tabs.List>
        <Tabs.Tab value="documents" leftSection={<IconFileText size={12} />}>
          Documents
        </Tabs.Tab>
        <Tabs.Tab value="templates" leftSection={<IconContract size={12} />}>
          Templates
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="documents" pt="md">
        <Outlet />
      </Tabs.Panel>
      <Tabs.Panel value="templates" pt="md">
        <DocumentGenerators />
      </Tabs.Panel>
    </Tabs>
  );
}
